import { motion } from 'framer-motion/dist/framer-motion';
import React from "react";
import perfil from '../../../assets/images/perfil.png';
import './Home.css';

const containerLeftVariants = {
    hidden: {
        x: '100vw',
    },
    visible: {
        x: '0',
        transition: {
            delay: 1,
            duration: 2,
            type: 'spring',
            stiffness: 150,
            damping: 12

        }
    },
}

const containerRightVariants = {
    hidden: {
        x: '-100vw',
    },
    visible: {
        x: '0',
        transition: {
            delay: 1,
            duration: 2,
            type: 'spring',
            stiffness: 150,
            damping: 12

        }
    },
}

const containerTopVariants = {
    hidden: {
        y: '-100vw',
    },
    visible: {
        y: '0',
        transition: {
            delay: 1,
            duration: 2,
            type: 'spring',
            stiffness: 150,
            damping: 12

        }
    },
}

const homeVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 2, rotate: 50 } }
    // hidden: { scale: 0 },
    // visible: { rotate: 360, scale: 1 },
    // transition: {
    //     duration: 1,
    //     type: "spring",
    //     stiffness: 260,
    //     damping: 5,


    // }
}
const Home = () => {

    return (
        <section class="home section" id="home">
            <motion.div class="home__container container grid"
                variants={homeVariants}
                initial="hidden"
                whileInView="visible">
                <div class="home__content grid">
                    <div
                        class="home__social"
                    >
                        <motion.a href="https://www.linkedin.com/" rel="noreferrer" target="_blank" class="home__social-icon"
                            variants={containerLeftVariants}
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                        >
                            <i class="uil uil-linkedin-alt"></i>
                        </motion.a>
                        <motion.a href="https://dribbble.com/" rel="noreferrer" target="_blank" class="home__social-icon"
                            variants={containerRightVariants}
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                        >
                            <i class="uil uil-dribbble"></i>
                        </motion.a>
                        <motion.a href="https://github.com" rel="noreferrer" target="_blank" class="home__social-icon"
                            variants={containerTopVariants}
                            initial="hidden"
                            animate="visible"


                            exit="exit"
                        >
                            <i class="uil uil-github-alt"></i>
                        </motion.a>
                    </div>

                    <div class="home__img" >
                        <svg class="home__blob" viewBox="0 0 200 187" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                            <mask id="mask0" mask-type="alpha">
                                <path d="M190.312 36.4879C206.582 62.1187 201.309 102.826 182.328 134.186C163.346 165.547 
                                130.807 187.559 100.226 186.353C69.6454 185.297 41.0228 161.023 21.7403 129.362C2.45775 
                                97.8511 -7.48481 59.1033 6.67581 34.5279C20.9871 10.1032 59.7028 -0.149132 97.9666 
                                0.00163737C136.23 0.303176 174.193 10.857 190.312 36.4879Z" />
                            </mask>
                            <g mask="url(#mask0)">
                                <path d="M190.312 36.4879C206.582 62.1187 201.309 102.826 182.328 134.186C163.346 
                                165.547 130.807 187.559 100.226 186.353C69.6454 185.297 41.0228 161.023 21.7403 
                                129.362C2.45775 97.8511 -7.48481 59.1033 6.67581 34.5279C20.9871 10.1032 59.7028 
                                -0.149132 97.9666 0.00163737C136.23 0.303176 174.193 10.857 190.312 36.4879Z" />
                                <motion.image class="home__blob-img" x="-30" y="-15" href={perfil} drag
                                    dragConstraints={{ top: 0, right: 0, left: 0, bottom: 0 }}
                                    dragElastic={0.8} variants={homeVariants}
                                    initial="hidden"
                                    animate="visible"


                                    exit="exit" />

                            </g>
                        </svg>

                    </div>
                    <div class="home__data">
                        <motion.h1 class="home__title" variants={containerLeftVariants}
                            initial="hidden"
                            animate="visible"
                            exit="exit">Hi, I'm Sourav</motion.h1>
                        <motion.h3 class="home__subtitle" variants={containerTopVariants}
                            initial="hidden"
                            animate="visible"
                            exit="exit">Full-Stack developer

                        </motion.h3>
                        <motion.p class="home__description" variants={containerRightVariants}
                            initial="hidden"
                            animate="visible"
                            exit="exit">I love to learn from each and everything</motion.p>
                        <motion.a href="#contact" class="button button--flex" whileHover={{ scale: 1.2 }}>
                            Contact Me <i class="uil uil-message button__icon"></i>
                        </motion.a>
                    </div>
                </div>
                <div class="home__scroll">
                    <a href="#about" class="home__scroll-button button--flex">
                        <i class="uil uil-mouse-alt-2 home__scroll-mouse"></i>
                        <span class="home__scroll-name">Scroll Down</span>
                        <i class="uil uil-arrow-down home__scroll-arrow"></i>
                    </a>
                </div>
            </motion.div>
        </section>
    )
}

export default Home